var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',_vm._b({staticClass:"my-4 pa-4",attrs:{"rounded":"","elevation":"2"}},'v-sheet',_vm.$attrs,false),[(_vm.title)?_c('div',{staticClass:"text-subtitle-1 font-weight-bold mb-1",domProps:{"textContent":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }